import _ from 'lodash'
export function  calcDiscount(disc,bsum){
  if(disc){
    if(disc.val_type=="percentage"){
      return parseFloat(bsum)*(disc.val/100)
    }else{
      return disc.val;
    }
  }else{
    return 0
  }
}


export function getBillSum(clsid, bsums) {
  if (!Array.isArray(bsums)) {
    console.error("getBillSum: bsums is not an array:", bsums);
    return 0;
  }

  const cbill = bsums.find(x => x && x.cid == clsid) || null;
  if (!cbill) {
    return 0;
  }

  const cbsum = Number(cbill.cbsum) || 0;
  return cbsum;
}


// single-rule factories
export const requiredRule = v => !!v || "this field is required"
export const passwordRules = [
  v => !!v || "Password is required",
  v => (v && v.length >= 8) || "Password must not be less than 8 characters"
]
export const emailRules = [
  v => (!v || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v)) || "E-mail must be valid"
]

// parameterized score rule (returns an array of validators)
export const scoreRules = (max = 50, label = "score") => [
  v => !!v || `${label} is required`,
  v => (v && v <= max) || `${label} cannot be more than ${max}%`
]

// factory that returns a full rules object (keeps backwards compat if desired)
export function makeValidRules({ cMax = 50, eMax = 50 } = {}) {
  return {
    required: [requiredRule],
    password: passwordRules,
    email: emailRules,
    email2: emailRules,
    c_score: scoreRules(cMax, "class score"),
    e_score: scoreRules(eMax, "exam score")
  }
}




// WEBPACK FOOTER //
// ./resources/assets/js/common/index.js